module.exports = __webpack_public_path__ + "static/img/logo@2x.2d0912cd.png";